<div class="formulario-grupo"
     [ngStyle]="firmanteCssVars"
     [class.formulario-grupo--inline]="inlineMode"
     [class.formulario-grupo--separado]="inlineMode && indexMostrar > 0">
  <div class="flex formulario-grupo__cabecera">
    <input type="checkbox"
           class="panel-firmante-card__checkbox"
           [checked]="estaSeleccionado"
           title="Resaltar casillas de este formulario en el PDF"
           [attr.aria-label]="'Resaltar casillas de ' + (nombre.value || 'formulario')"
           (click)="$event.stopPropagation()"
           (change)="onHighlightCheckboxChange($event)">
    <label class="formulario-grupo__label">Formulario</label>
    <form [formGroup]="formulario">
      <input id="inputNombreId" type="text" formControlName="nombre" (input)="sincronizarNombreEnBorrador()" (blur)="onNombreBlur()" [ngClass]="formularioValidacionesDocsService.isCampoValidoArrayFormulariosCombinado(formulario,this.obtenerIndexNifArray()) ? 'errorInput' : ''">
    </form>
    <svg id="addFormularioId" class="icon-plus" (click)="addFormulario()">
      <use xlink:href="#icon-plus"></use>
    </svg>
    <svg id="deleteFormularioId" class="icon-delete" (click)="deleteFormulario()">
      <use xlink:href="#hs-bin"></use>
    </svg>
  </div>
  <p class="texto-validacion formulario-grupo__error" *ngIf="formularioValidacionesDocsService.isCampoValidoArrayFormulariosCombinado(formulario, obtenerIndexNifArray())">
    {{formularioValidacionesDocsService.mensajeErrorNombreFormulario}}
  </p>
  <div class="flex-boton-checkbox" [formGroup]="formulario">
    <div class="flex-anadir">
      <div #botonAnadir>
        <app-boton-accion id="btnAnadirId" [icono]="'icon-plus'" [titulo]="'añadir campo'" (botonClicked)="getPosicion($event)"></app-boton-accion>
      </div>
    </div>
    <div class="checkbox-container">
      <input type="checkbox" formControlName="obligatorio" (change)="onObligatorioChange($event)">
      <label>Obligatorio</label>
    </div>
  </div>
</div>

<app-casillas-temporal *ngFor="let casilla of casillaMoverArray" [posicionCasilla]="posicionCasilla" #casillasTemporalComponent></app-casillas-temporal>
